import { render } from "./DateTimeEdit.vue?vue&type=template&id=2c23fa68"
import script from "./DateTimeEdit.vue?vue&type=script&lang=js"
export * from "./DateTimeEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__